import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      // Navigation
      "nav.home": "Ana Sayfa",
      "nav.exhibitions": "Fuarlar",
      "nav.countries": "Ülkeler",
      "nav.admin": "Admin",
      "nav.login": "Giriş Yap",
      "nav.logout": "Çıkış Yap",
      "nav.about": "Hakkımızda",
      "nav.certificates": "Sertifikalar",
      "nav.careers": "İnsan Kaynakları",
      "nav.contact": "İletişim",

      // Common
      "common.loading": "Yükleniyor...",
      "common.error": "Hata oluştu",
      "common.save": "Kaydet",
      "common.cancel": "İptal",
      "common.delete": "Sil",
      "common.edit": "Düzenle",
      "common.add": "Ekle",
      "common.back": "Geri",
      "common.next": "İleri",
      "common.previous": "Önceki",
      "common.close": "Kapat",
      "common.search": "Ara",
      "common.filter": "Filtrele",
      "common.all": "Tümü",
      "common.yes": "Evet",
      "common.no": "Hayır",
      "common.confirm": "Onayla",
      "common.schedule_call": "Görüşme Planla",
      "whatsapp.message": "Merhaba! Tekstaş hakkında bilgi almak istiyorum.",
      "whatsapp.tooltip": "WhatsApp'tan Mesaj Gönder",

      // Home page
      "home.welcome": "Hoş Geldiniz",
      "home.description": "Dünya çapında sergileri keşfedin",
      "home.featured_exhibitions": "Öne Çıkan Fuarlar",
      "home.view_all": "Tümünü Görüntüle",

      // Hero Section
      "hero.global_partner": "Küresel Tekstil Partneriniz",
      "hero.reliable_production": "Güvenilir Üretim Yüksek Kalite Kumaşlar",
      "hero.global_partner_desc":
        "Tekstil sektöründe güvenilir üretim ve yüksek kalite standartlarıyla hizmet veriyoruz",
      "hero.innovation": "Tekstilde İnovasyon",
      "hero.premium_solutions": "Premium Kalite Sürdürülebilir Çözümler",
      "hero.innovation_desc":
        "İnovatif çözümlerimizle tekstil üretiminin geleceğini deneyimleyin",

      // Products Section
      "products.title":
        "1980’den bu yana dokuma kumaş üretiminde uzmanlaşan bir marka olarak, üretim süreçlerimizde doğal elyafları merkeze alıyoruz. Müşterilerimizin ihtiyaçlarına göre siparişe özel üretim yapıyor, her aşamada kalite standartlarımızdan ödün vermiyoruz. Deneyimimiz ve titiz iş anlayışımızla, güvenilir ve sürdürülebilir üretimi ilke ediniyoruz.",
      "products.description":
        "1980’den bu yana dokuma kumaş üretiminde uzmanlaşan bir marka olarak, üretim süreçlerimizde doğal elyafları merkeze alıyoruz. Müşterilerimizin ihtiyaçlarına göre siparişe özel üretim yapıyor, her aşamada kalite standartlarımızdan ödün vermiyoruz. Deneyimimiz ve titiz iş anlayışımızla, güvenilir ve sürdürülebilir üretimi ilke ediniyoruz.",

      // Features Section
      "features.title": "Ürünlerimiz",
      "features.description":
        "Dikkatle seçilmiş premium kumaş koleksiyonumuzu keşfedin. Nefes alabilir pamuktan lüks ketene ve dayanıklı dimiye kadar, her kumaş gömlekleriniz için stil, konfor ve uzun ömürlü kalite sunmak üzere üretilmiştir.",
      "features.view_all": "Tüm Kumaşları Gör",
      "features.cotton.title": "Pamuk",
      "features.cotton.description":
        "Yumuşak, nefes alabilir ve dayanıklı pamuk kumaşlarımız, tüm gömlek türleri için nihai konfor ve çok yönlülük sunar. Hem günlük hem de resmi giyim için mükemmel olan bu kumaşlar, gün boyunca konforu korurken net bir görünüm sağlar.",
      "features.linen.title": "Keten",
      "features.linen.description":
        "Keten kumaşlarımız hafif, havadar ve sıcak havalar için mükemmeldir. Doğal dokuları ve nefes alabilirlikleriyle bilinen keten gömlekler, rahat ama sofistike bir stil için idealdir.",
      "features.twill.title": "Dimi",
      "features.twill.description":
        "Dimi kumaşlar, pürüzsüz yüzeyleri ve zarif çapraz dokularıyla lüks bir his verir. Bu kumaşlar, zarif ve şık görünümlü, dayanıklı, yüksek kaliteli gömlekler yaratmak için mükemmeldir.",

      // Certificates Section
      "certificates.title": "Sertifikalarımız",
      "certificates.subtitle": "Tekstil üretiminde mükemmellik standartları",
      "certificates.iso.title": "ISO 9001:2015",
      "certificates.iso.description":
        "Yüksek kaliteli tekstil ürünleri ve hizmetleri sunma taahhüdümüzü garanti eden uluslararası kalite yönetim sistemi sertifikası.",
      "certificates.gots.title": "GOTS Sertifikası",
      "certificates.gots.description":
        "Organik tekstil üretimi ve sürdürülebilir uygulamalara olan bağlılığımızı doğrulayan Küresel Organik Tekstil Standardı sertifikası.",
      "certificates.ocs.title": "OCS Sertifikası",
      "certificates.ocs.description":
        "Organic Content Standard, organik tarımsal üretimi artırmayı amaçlar.",
      "certificates.rcs.title": "RCS Sertifikası",
      "certificates.rcs.description":
        "Global Organic Textile Standard (GOTS) ve Textile Exchange, tekstil ve konfeksiyon endüstrisindeki en yaygın iki sertifikasyon programıdır. GOTS öncelikle organik tekstil sertifikasına odaklanırken, Textile Exchange organik, geri dönüştürülmüş ve sorumlu materyallerle ilgili birçok tanınmış standardı yürütmektedir.",

      // Fairs Section
      "fairs.title": "Fuarlarımız",
      "fairs.subtitle": "Dünya çapındaki tekstil fuarlarında yerimizi alıyoruz",
      "fairs.view_all": "Tüm Fuarları Görüntüle",

      // Careers Section
      "careers.title": "Ekibimize Katılın",
      "careers.description":
        "Büyüyen ekibimize katılmak için yetenekli bireyler arıyoruz. Tekstil ve inovasyona tutkuluysanız, sizden haber almak isteriz. Başvurunuzu gönderin ve başarı hikayemizin bir parçası olun.",
      "careers.form.full_name": "Ad Soyad",
      "careers.form.full_name_placeholder": "Adınızı ve soyadınızı girin",
      "careers.form.email": "E-posta",
      "careers.form.email_placeholder": "E-posta adresinizi girin",
      "careers.form.phone": "Telefon",
      "careers.form.phone_placeholder": "Telefon numaranızı girin",
      "careers.form.position": "Pozisyon",
      "careers.form.position_placeholder": "Başvurduğunuz pozisyon",
      "careers.form.message": "Mesaj",
      "careers.form.message_placeholder": "Mesajınız",
      "careers.form.file": "CV / Dosya Ekle",
      "careers.form.file_selected": "Seçilen dosya:",
      "careers.form.file_size_error": "Dosya boyutu 5MB'dan küçük olmalıdır",
      "careers.form.file_type_error":
        "Sadece JPG, PNG ve PDF dosyaları kabul edilir",
      "careers.form.file_help":
        "JPG, PNG veya PDF dosyası yükleyebilirsiniz. Maksimum dosya boyutu: 5MB",
      "careers.form.submit": "Başvuruyu Gönder",
      "careers.success.title": "Başarılı!",
      "careers.success.message":
        "Başvurunuz başarıyla gönderildi. Yakında sizinle iletişime geçeceğiz.",
      "careers.success.close": "Kapat",
      "careers.error":
        "Başvuru gönderilirken hata oluştu. Lütfen tekrar deneyin.",

      // Contact Section
      "contact.title": "İletişim",
      "contact.description":
        "Bizimle iletişime geçin. Sorularınız, önerileriniz veya işbirliği talepleriniz için aşağıdaki formu kullanabilirsiniz. En kısa sürede size geri dönüş yapacağız.",
      "contact.form.full_name": "Ad Soyad",
      "contact.form.full_name_placeholder": "Adınızı ve soyadınızı girin",
      "contact.form.email": "E-posta",
      "contact.form.email_placeholder": "E-posta adresinizi girin",
      "contact.form.phone": "Telefon",
      "contact.form.phone_placeholder": "Telefon numaranızı girin (opsiyonel)",
      "contact.form.message": "Mesaj",
      "contact.form.message_placeholder": "Mesajınızı buraya yazın...",
      "contact.form.submit": "Mesajı Gönder",
      "contact.success.title": "Başarılı!",
      "contact.success.message":
        "Mesajınız başarıyla gönderildi. En kısa sürede size geri dönüş yapacağız.",
      "contact.success.close": "Kapat",
      "contact.error":
        "Mesaj gönderilirken hata oluştu. Lütfen tekrar deneyin.",

      // Exhibitions
      "exhibitions.title": "Fuarlar",
      "exhibitions.add_new": "Yeni Sergi Ekle",
      "exhibitions.name": "Sergi Adı",
      "exhibitions.description": "Açıklama",
      "exhibitions.country": "Ülke",
      "exhibitions.city": "Şehir",
      "exhibitions.date": "Tarih",
      "exhibitions.start_date": "Başlangıç Tarihi",
      "exhibitions.end_date": "Bitiş Tarihi",
      "exhibitions.venue": "Mekan",
      "exhibitions.organizer": "Organizatör",
      "exhibitions.website": "Website",
      "exhibitions.contact": "İletişim",
      "exhibitions.photos": "Fotoğraflar",
      "exhibitions.add_photo": "Fotoğraf Ekle",
      "exhibitions.remove_photo": "Fotoğrafı Kaldır",
      "exhibitions.no_photos": "Henüz fotoğraf yok",
      "exhibitions.view_details": "Detayları Görüntüle",
      "exhibitions.edit_exhibition": "Sergiyi Düzenle",
      "exhibitions.delete_exhibition": "Sergiyi Sil",
      "exhibitions.confirm_delete":
        "Bu sergiyi silmek istediğinizden emin misiniz?",
      "exhibitions.created_successfully": "Sergi başarıyla oluşturuldu",
      "exhibitions.updated_successfully": "Sergi başarıyla güncellendi",
      "exhibitions.deleted_successfully": "Sergi başarıyla silindi",
      "exhibitions.loading_error": "Sergiler yüklenirken hata oluştu",

      // Countries
      "countries.title": "Ülkeler",
      "countries.add_new": "Yeni Ülke Ekle",
      "countries.name": "Ülke Adı",
      "countries.code": "Ülke Kodu",
      "countries.flag": "Bayrak",
      "countries.capital": "Başkent",
      "countries.population": "Nüfus",
      "countries.region": "Bölge",
      "countries.subregion": "Alt Bölge",
      "countries.languages": "Diller",
      "countries.currencies": "Para Birimleri",
      "countries.timezones": "Saat Dilimleri",
      "countries.view_exhibitions": "Sergileri Görüntüle",
      "countries.edit_country": "Ülkeyi Düzenle",
      "countries.delete_country": "Ülkeyi Sil",
      "countries.confirm_delete":
        "Bu ülkeyi silmek istediğinizden emin misiniz?",
      "countries.created_successfully": "Ülke başarıyla oluşturuldu",
      "countries.updated_successfully": "Ülke başarıyla güncellendi",
      "countries.deleted_successfully": "Ülke başarıyla silindi",
      "countries.loading_error": "Ülkeler yüklenirken hata oluştu",

      // Admin
      "admin.title": "Admin Paneli",
      "admin.dashboard": "Dashboard",
      "admin.manage_exhibitions": "Sergileri Yönet",
      "admin.manage_countries": "Ülkeleri Yönet",
      "admin.manage_users": "Kullanıcıları Yönet",
      "admin.settings": "Ayarlar",
      "admin.statistics": "İstatistikler",
      "admin.total_exhibitions": "Toplam Sergi",
      "admin.total_countries": "Toplam Ülke",
      "admin.total_users": "Toplam Kullanıcı",
      "admin.recent_activity": "Son Aktiviteler",

      // Admin Contact Messages
      "admin.contact_messages.title": "İletişim Mesajları",
      "admin.contact_messages.name": "Ad Soyad",
      "admin.contact_messages.email": "E-posta",
      "admin.contact_messages.phone": "Telefon",
      "admin.contact_messages.message": "Mesaj",
      "admin.contact_messages.status": "Durum",
      "admin.contact_messages.date": "Tarih",
      "admin.contact_messages.message_details": "Mesaj Detayları",
      "admin.contact_messages.mark_read": "Okundu Olarak İşaretle",
      "admin.contact_messages.mark_replied": "Yanıtlandı Olarak İşaretle",
      "admin.contact_messages.no_messages": "Henüz mesaj bulunmuyor",

      // Auth
      "auth.login": "Giriş Yap",
      "auth.logout": "Çıkış Yap",
      "auth.register": "Kayıt Ol",
      "auth.email": "E-posta",
      "auth.password": "Şifre",
      "auth.confirm_password": "Şifreyi Onayla",
      "auth.remember_me": "Beni Hatırla",
      "auth.forgot_password": "Şifremi Unuttum",
      "auth.login_successful": "Başarıyla giriş yapıldı",
      "auth.logout_successful": "Başarıyla çıkış yapıldı",
      "auth.invalid_credentials": "Geçersiz e-posta veya şifre",
      "auth.required_field": "Bu alan zorunludur",
      "auth.invalid_email": "Geçersiz e-posta adresi",
      "auth.password_mismatch": "Şifreler eşleşmiyor",

      // Forms
      "form.required": "Bu alan zorunludur",
      "form.invalid_format": "Geçersiz format",
      "form.min_length": "En az {{min}} karakter olmalıdır",
      "form.max_length": "En fazla {{max}} karakter olmalıdır",
      "form.invalid_url": "Geçersiz URL",
      "form.invalid_date": "Geçersiz tarih",

      // Messages
      "message.success": "İşlem başarılı",
      "message.error": "Bir hata oluştu",
      "message.warning": "Uyarı",
      "message.info": "Bilgi",

      // Language
      "language.turkish": "Türkçe",
      "language.english": "English",
      "language.german": "Deutsch",
      "language.spanish": "Español",
      "language.french": "Français",
      "language.select": "Dil Seçin",
      "language.change": "Dili Değiştir",

      // Footer
      "footer.description":
        "1980’den bu yana dokuma kumaş üretiminde uzmanlaşan bir marka olarak, üretim süreçlerimizde doğal elyafları merkeze alıyoruz. Müşterilerimizin ihtiyaçlarına göre siparişe özel üretim yapıyor, her aşamada kalite standartlarımızdan ödün vermiyoruz. Deneyimimiz ve titiz iş anlayışımızla, güvenilir ve sürdürülebilir üretimi ilke ediniyoruz.",
      "footer.quick_links": "Hızlı Linkler",
      "footer.about": "Hakkımızda",
      "footer.careers": "Kariyer",
      "footer.contact": "İletişim",
      "footer.email": "E-posta: info@tekstas.com",
      "footer.phone": "Telefon: +90 123 456 7890",
      "footer.address": "Adres: İstanbul, Türkiye",
      "footer.follow_us": "Bizi Takip Edin",
      "footer.copyright": "© 2023 Tekstas. Tüm hakları saklıdır.",

      // About Section
      "about.title": "Hakkımızda",
    },
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.exhibitions": "Exhibitions",
      "nav.countries": "Countries",
      "nav.admin": "Admin",
      "nav.login": "Login",
      "nav.logout": "Logout",
      "nav.about": "About",
      "nav.certificates": "Certificates",
      "nav.careers": "Human Resources",
      "nav.contact": "Contact",

      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.add": "Add",
      "common.back": "Back",
      "common.next": "Next",
      "common.previous": "Previous",
      "common.close": "Close",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.all": "All",
      "common.yes": "Yes",
      "common.no": "No",
      "common.confirm": "Confirm",
      "common.schedule_call": "Schedule a Call",
      "whatsapp.message":
        "Hello! I would like to get information about Tekstaş.",
      "whatsapp.tooltip": "Send Message via WhatsApp",

      // Home page
      "home.welcome": "Welcome",
      "home.description": "Discover exhibitions around the world",
      "home.featured_exhibitions": "Featured Exhibitions",
      "home.view_all": "View All",

      // Hero Section
      "hero.global_partner": "Your Global Textile Partner",
      "hero.reliable_production": "Reliable Production High Quality Fabrics",
      "hero.global_partner_desc":
        "Lorem upsum dolor sit ametLorem upsum dolor sit amet Lorem upsum dolor sit amet",
      "hero.innovation": "Innovation in Textile",
      "hero.premium_solutions": "Premium Quality Sustainable Solutions",
      "hero.innovation_desc":
        "Experience the future of textile manufacturing with our innovative solutions",

      // Products Section
      "products.title":
        "As a brand specializing in woven fabric production since 1980, we place natural fibers at the core of our production processes. We produce made-to-order according to our customers' needs and never compromise our quality standards at any stage. With our experience and meticulous work ethic, we are committed to reliable and sustainable production.",
      "products.description":
        "As a brand specializing in woven fabric production since 1980, we place natural fibers at the core of our production processes. We produce made-to-order according to our customers' needs and never compromise our quality standards at any stage. With our experience and meticulous work ethic, we are committed to reliable and sustainable production.",

      // Features Section
      "features.title": "Our Products",
      "features.description":
        "Explore our carefully curated selection of premium fabrics. From breathable cotton to luxurious linen and durable twill, each fabric is crafted to deliver style, comfort, and long-lasting quality for your shirts.",
      "features.view_all": "View All Fabrics",
      "features.cotton.title": "Cotton",
      "features.cotton.description":
        "Soft, breathable, and durable, our cotton fabrics offer ultimate comfort and versatility for all types of shirts. Perfect for both casual and formal wear, they provide a crisp look while maintaining comfort throughout the day.",
      "features.linen.title": "Linen",
      "features.linen.description":
        "Our linen fabrics are light, airy, and perfect for warm weather. Known for their natural texture and breathability, linen shirts are ideal for a relaxed yet sophisticated style.",
      "features.twill.title": "Twill",
      "features.twill.description":
        "Twill fabrics provide a luxurious feel with their smooth finish and subtle diagonal weave. These fabrics are perfect for creating durable, high-quality shirts with a refined, elegant look.",

      // Certificates Section
      "certificates.title": "Our Certifications",
      "certificates.subtitle":
        "Recognized standards of excellence in textile manufacturing",
      "certificates.iso.title": "ISO 9001:2015",
      "certificates.iso.description":
        "International quality management system certification ensuring our commitment to providing high-quality textile products and services.",
      "certificates.gots.title": "GOTS Certification",
      "certificates.gots.description":
        "Certification of the Global Organic Textile Standard confirming our dedication to organic textile production and sustainable practices.",
      "certificates.ocs.title": "OCS Certification",
      "certificates.ocs.description":
        "The Organic Content Standard aims to increase organic agricultural production.",
      "certificates.rcs.title": "RCS Certification",
      "certificates.rcs.description":
        "Global Organic Textile Standard (GOTS) and Textile Exchange are the two most common certification programmes in textiles and garment industry. GOTS focuses primarily on organic textile certification, while Textile Exchange runs several widely recognised standards around organic, recycle and responsible materials.",

      // Fairs Section
      "fairs.title": "Our Trade Fairs",
      "fairs.subtitle": "Taking our place in worldwide textile exhibitions",
      "fairs.view_all": "View All Fairs",

      // Careers Section
      "careers.title": "Join Our Team",
      "careers.description":
        "We're always looking for talented individuals to join our growing team. If you're passionate about textile and innovation, we'd love to hear from you. Submit your application and become part of our success story.",
      "careers.form.full_name": "Full Name",
      "careers.form.full_name_placeholder": "Enter your full name",
      "careers.form.email": "Email",
      "careers.form.email_placeholder": "Enter your email",
      "careers.form.phone": "Phone",
      "careers.form.phone_placeholder": "Enter your phone number",
      "careers.form.position": "Position",
      "careers.form.position_placeholder": "Position you're applying for",
      "careers.form.message": "Message",
      "careers.form.message_placeholder": "Your message",
      "careers.form.file": "CV / File Upload",
      "careers.form.file_selected": "Selected file:",
      "careers.form.file_size_error": "File size must be less than 5MB",
      "careers.form.file_type_error":
        "Only JPG, PNG and PDF files are accepted",
      "careers.form.file_help":
        "You can upload JPG, PNG or PDF files. Maximum file size: 5MB",
      "careers.form.submit": "Submit Application",
      "careers.success.title": "Success!",
      "careers.success.message":
        "Your application has been successfully submitted. We will contact you soon.",
      "careers.success.close": "Close",
      "careers.error": "Error submitting application. Please try again.",

      // Contact Section
      "contact.title": "Contact",
      "contact.description":
        "Get in touch with us. You can use the form below for your questions, suggestions, or collaboration requests. We will get back to you as soon as possible.",
      "contact.form.full_name": "Full Name",
      "contact.form.full_name_placeholder": "Enter your full name",
      "contact.form.email": "Email",
      "contact.form.email_placeholder": "Enter your email address",
      "contact.form.phone": "Phone",
      "contact.form.phone_placeholder": "Enter your phone number (optional)",
      "contact.form.message": "Message",
      "contact.form.message_placeholder": "Write your message here...",
      "contact.form.submit": "Send Message",
      "contact.success.title": "Success!",
      "contact.success.message":
        "Your message has been sent successfully. We will get back to you as soon as possible.",
      "contact.success.close": "Close",
      "contact.error": "Error sending message. Please try again.",

      // Exhibitions
      "exhibitions.title": "Exhibitions",
      "exhibitions.add_new": "Add New Exhibition",
      "exhibitions.name": "Exhibition Name",
      "exhibitions.description": "Description",
      "exhibitions.country": "Country",
      "exhibitions.city": "City",
      "exhibitions.date": "Date",
      "exhibitions.start_date": "Start Date",
      "exhibitions.end_date": "End Date",
      "exhibitions.venue": "Venue",
      "exhibitions.organizer": "Organizer",
      "exhibitions.website": "Website",
      "exhibitions.contact": "Contact",
      "exhibitions.photos": "Photos",
      "exhibitions.add_photo": "Add Photo",
      "exhibitions.remove_photo": "Remove Photo",
      "exhibitions.no_photos": "No photos yet",
      "exhibitions.view_details": "View Details",
      "exhibitions.edit_exhibition": "Edit Exhibition",
      "exhibitions.delete_exhibition": "Delete Exhibition",
      "exhibitions.confirm_delete":
        "Are you sure you want to delete this exhibition?",
      "exhibitions.created_successfully": "Exhibition created successfully",
      "exhibitions.updated_successfully": "Exhibition updated successfully",
      "exhibitions.deleted_successfully": "Exhibition deleted successfully",
      "exhibitions.loading_error": "Error loading exhibitions",

      // Countries
      "countries.title": "Countries",
      "countries.add_new": "Add New Country",
      "countries.name": "Country Name",
      "countries.code": "Country Code",
      "countries.flag": "Flag",
      "countries.capital": "Capital",
      "countries.population": "Population",
      "countries.region": "Region",
      "countries.subregion": "Subregion",
      "countries.languages": "Languages",
      "countries.currencies": "Currencies",
      "countries.timezones": "Timezones",
      "countries.view_exhibitions": "View Exhibitions",
      "countries.edit_country": "Edit Country",
      "countries.delete_country": "Delete Country",
      "countries.confirm_delete":
        "Are you sure you want to delete this country?",
      "countries.created_successfully": "Country created successfully",
      "countries.updated_successfully": "Country updated successfully",
      "countries.deleted_successfully": "Country deleted successfully",
      "countries.loading_error": "Error loading countries",

      // Admin
      "admin.title": "Admin Panel",
      "admin.dashboard": "Dashboard",
      "admin.manage_exhibitions": "Manage Exhibitions",
      "admin.manage_countries": "Manage Countries",
      "admin.manage_users": "Manage Users",
      "admin.settings": "Settings",
      "admin.statistics": "Statistics",
      "admin.total_exhibitions": "Total Exhibitions",
      "admin.total_countries": "Total Countries",
      "admin.total_users": "Total Users",
      "admin.recent_activity": "Recent Activity",

      // Admin Contact Messages
      "admin.contact_messages.title": "Contact Messages",
      "admin.contact_messages.name": "Full Name",
      "admin.contact_messages.email": "Email",
      "admin.contact_messages.phone": "Phone",
      "admin.contact_messages.message": "Message",
      "admin.contact_messages.status": "Status",
      "admin.contact_messages.date": "Date",
      "admin.contact_messages.message_details": "Message Details",
      "admin.contact_messages.mark_read": "Mark as Read",
      "admin.contact_messages.mark_replied": "Mark as Replied",
      "admin.contact_messages.no_messages": "No messages yet",

      // Auth
      "auth.login": "Login",
      "auth.logout": "Logout",
      "auth.register": "Register",
      "auth.email": "E-mail",
      "auth.password": "Password",
      "auth.confirm_password": "Confirm Password",
      "auth.remember_me": "Remember Me",
      "auth.forgot_password": "Forgot Password",
      "auth.login_successful": "Successfully logged in",
      "auth.logout_successful": "Successfully logged out",
      "auth.invalid_credentials": "Invalid email or password",
      "auth.required_field": "This field is required",
      "auth.invalid_email": "Invalid email address",
      "auth.password_mismatch": "Passwords do not match",

      // Forms
      "form.required": "This field is required",
      "form.invalid_format": "Invalid format",
      "form.min_length": "Must be at least {{min}} characters",
      "form.max_length": "Must be at most {{max}} characters",
      "form.invalid_url": "Invalid URL",
      "form.invalid_date": "Invalid date",

      // Messages
      "message.success": "Operation successful",
      "message.error": "An error occurred",
      "message.warning": "Warning",
      "message.info": "Information",

      // Language
      "language.turkish": "Türkçe",
      "language.english": "English",
      "language.german": "Deutsch",
      "language.spanish": "Español",
      "language.french": "Français",
      "language.select": "Select Language",
      "language.change": "Change Language",

      // Footer
      "footer.description":
        "Leading the way in textile manufacturing with innovation and quality.",
      "footer.quick_links": "Quick Links",
      "footer.about": "About",
      "footer.careers": "Careers",
      "footer.contact": "Contact",
      "footer.email": "Email: info@tekstas.com",
      "footer.phone": "Phone: +90 123 456 7890",
      "footer.address": "Address: Istanbul, Turkey",
      "footer.follow_us": "Follow Us",
      "footer.copyright": "© 2023 Tekstas. All rights reserved.",

      // About Section
      "about.title": "About Us",
    },
  },
  de: {
    translation: {
      // Navigation
      "nav.home": "Startseite",
      "nav.exhibitions": "Ausstellungen",
      "nav.countries": "Länder",
      "nav.admin": "Admin",
      "nav.login": "Anmelden",
      "nav.logout": "Abmelden",
      "nav.about": "Über uns",
      "nav.certificates": "Zertifikate",
      "nav.careers": "Personalwesen",
      "nav.contact": "Kontakt",

      // Common
      "common.loading": "Lädt...",
      "common.error": "Ein Fehler ist aufgetreten",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.delete": "Löschen",
      "common.edit": "Bearbeiten",
      "common.add": "Hinzufügen",
      "common.back": "Zurück",
      "common.next": "Weiter",
      "common.previous": "Zurück",
      "common.close": "Schließen",
      "common.search": "Suchen",
      "common.filter": "Filter",
      "common.all": "Alle",
      "common.yes": "Ja",
      "common.no": "Nein",
      "common.confirm": "Bestätigen",
      "common.schedule_call": "Anruf planen",

      // Home page
      "home.welcome": "Willkommen",
      "home.description": "Entdecken Sie Ausstellungen weltweit",
      "home.featured_exhibitions": "Ausgewählte Ausstellungen",
      "home.view_all": "Alle anzeigen",

      // Hero Section
      "hero.global_partner": "Ihr globaler Textilpartner",
      "hero.reliable_production": "Zuverlässige Produktion Hochwertige Stoffe",
      "hero.global_partner_desc":
        "Wir bieten zuverlässige Produktion und hohe Qualitätsstandards in der Textilbranche",
      "hero.innovation": "Innovation in der Textilindustrie",
      "hero.premium_solutions": "Premium-Qualität Nachhaltige Lösungen",
      "hero.innovation_desc":
        "Erleben Sie die Zukunft der Textilherstellung mit unseren innovativen Lösungen",

      // Products Section
      "products.title":
        "Seit 1980 produziert Tekstaş Textil gefärbte Stoffe aus den feinsten Rohmaterialien.\nTekstaş bietet jährlich zwei Hauptkollektionen und zwei Kapselkollektionen an. Wir dienen der Branche mit periodisch vorbereiteten Kapselkollektionen und Sonderprodukten.\nDie Tekstaş-Produktionslinie verwendet typischerweise Baumwolle-, Polyester-, Viskose-, Nylon-, Wolle-, Leinen- und Terylen-Mischungen. Die Produkte richten sich allgemein an die Damen-, Herren- und Kinderbekleidungssektoren.\nUnsere Produkte finden sich in den Kollektionen vieler renommierter Marken, hauptsächlich in Frankreich, Spanien, Deutschland, Kanada und Griechenland.",
      "products.description":
        "1980'den beri Tekstaş Tekstil, en iyi hammaddelerle elde edilen ipliklerden boyalı kumaşlar üretmektedir.\nTekstaş, her yıl iki ana koleksiyon ve iki kapsül koleksiyonu sunmaktadır. Periyodik olarak hazırlanan kapsül koleksiyonları ve özel ürünler ile sektöre hizmet vermektedir.\nTekstaş üretim bandı genellikle pamuk, polyester, viskon, naylon, yün, keten, tere karışımı kullanmaktadır. Ürünler genel olarak kadın, erkek ve çocuk giyim sektörüne yöneliktir.\nÜrünlerimiz başta Fransa, İspanya, Almanya, Kanada ve Yunanistan olmak üzere birçok seçkin markanın koleksiyonunda bulunmaktadır.",

      // Features Section
      "features.title": "Unser Produkt",
      "features.description":
        "Entdecken Sie unsere sorgfältig kuratierte Auswahl an Premium-Stoffen. Von atmungsaktiver Baumwolle bis hin zu luxuriösem Leinen und strapazierfähigem Köper - jeder Stoff ist darauf ausgerichtet, Stil, Komfort und langlebige Qualität für Ihre Hemden zu liefern.",
      "features.view_all": "Alle Stoffe anzeigen",
      "features.cotton.title": "Baumwolle",
      "features.cotton.description":
        "Weich, atmungsaktiv und langlebig - unsere Baumwollstoffe bieten ultimativen Komfort und Vielseitigkeit für alle Arten von Hemden. Perfekt für sowohl lässige als auch formelle Kleidung, bieten sie einen frischen Look und behalten den ganzen Tag über den Komfort bei.",
      "features.linen.title": "Leinen",
      "features.linen.description":
        "Unsere Leinenstoffe sind leicht, luftig und perfekt für warmes Wetter. Bekannt für ihre natürliche Textur und Atmungsaktivität sind Leinenhemden ideal für einen entspannten, aber sophistizierten Stil.",
      "features.twill.title": "Köper",
      "features.twill.description":
        "Köperstoffe bieten ein luxuriöses Gefühl mit ihrer glatten Oberfläche und subtilen diagonalen Webart. Diese Stoffe sind perfekt für die Herstellung langlebiger, hochwertiger Hemden mit einem raffinierten, eleganten Look.",

      // Certificates Section
      "certificates.title": "Unsere Zertifikate",
      "certificates.subtitle":
        "Anerkannte Exzellenzstandards in der Textilherstellung",
      "certificates.iso.title": "ISO 9001:2015",
      "certificates.iso.description":
        "Internationale Qualitätsmanagementsystem-Zertifizierung, die unser Engagement für hochwertige Textilprodukte und -dienstleistungen sicherstellt.",
      "certificates.gots.title": "GOTS-Zertifizierung",
      "certificates.gots.description":
        "Global Organic Textile Standard-Zertifizierung, die unser Engagement für biologische Textilproduktion und nachhaltige Praktiken bestätigt.",
      "certificates.ocs.title": "OCS-Zertifizierung",
      "certificates.ocs.description":
        "Der Organic Content Standard zielt darauf ab, die ökologische Landwirtschaft zu fördern.",
      "certificates.rcs.title": "RCS-Zertifizierung",
      "certificates.rcs.description":
        "Global Organic Textile Standard (GOTS) und Textile Exchange sind die beiden am häufigsten verwendeten Zertifizierungsprogramme in der Textil- und Bekleidungsindustrie. GOTS konzentriert sich hauptsächlich auf die Zertifizierung von Bio-Textilien, während Textile Exchange mehrere anerkannte Standards für Bio-, Recycling- und verantwortungsvolle Materialien betreibt.",

      // Fairs Section
      "fairs.title": "Unsere Messen",
      "fairs.subtitle": "Wir nehmen an weltweiten Textilausstellungen teil",
      "fairs.view_all": "Alle Messen anzeigen",

      // Careers Section
      "careers.title": "Werden Sie Teil unseres Teams",
      "careers.description":
        "Wir suchen immer talentierte Menschen, die unser wachsendes Team verstärken. Wenn Sie leidenschaftlich an Textil und Innovation interessiert sind, würden wir gerne von Ihnen hören. Reichen Sie Ihre Bewerbung ein und werden Sie Teil unserer Erfolgsgeschichte.",
      "careers.form.full_name": "Vollständiger Name",
      "careers.form.full_name_placeholder":
        "Geben Sie Ihren vollständigen Namen ein",
      "careers.form.email": "E-Mail",
      "careers.form.email_placeholder": "Geben Sie Ihre E-Mail-Adresse ein",
      "careers.form.phone": "Telefon",
      "careers.form.phone_placeholder": "Geben Sie Ihre Telefonnummer ein",
      "careers.form.position": "Position",
      "careers.form.position_placeholder":
        "Position, für die Sie sich bewerben",
      "careers.form.message": "Nachricht",
      "careers.form.message_placeholder": "Ihre Nachricht",
      "careers.form.file": "CV / Datei hochladen",
      "careers.form.file_selected": "Ausgewählte Datei:",
      "careers.form.file_size_error": "Dateigröße muss kleiner als 5MB sein",
      "careers.form.file_type_error":
        "Nur JPG, PNG und PDF-Dateien werden akzeptiert",
      "careers.form.file_help":
        "Sie können JPG, PNG oder PDF-Dateien hochladen. Maximale Dateigröße: 5MB",
      "careers.form.submit": "Bewerbung einreichen",
      "careers.success.title": "Erfolg!",
      "careers.success.message":
        "Ihre Bewerbung wurde erfolgreich eingereicht. Wir werden uns bald mit Ihnen in Verbindung setzen.",
      "careers.success.close": "Schließen",
      "careers.error":
        "Fehler beim Einreichen der Bewerbung. Bitte versuchen Sie es erneut.",

      // Contact Section
      "contact.title": "Kontakt",
      "contact.description":
        "Nehmen Sie Kontakt mit uns auf. Sie können das untenstehende Formular für Ihre Fragen, Vorschläge oder Kooperationsanfragen verwenden. Wir werden uns so schnell wie möglich bei Ihnen melden.",
      "contact.form.full_name": "Vollständiger Name",
      "contact.form.full_name_placeholder":
        "Geben Sie Ihren vollständigen Namen ein",
      "contact.form.email": "E-Mail",
      "contact.form.email_placeholder": "Geben Sie Ihre E-Mail-Adresse ein",
      "contact.form.phone": "Telefon",
      "contact.form.phone_placeholder":
        "Geben Sie Ihre Telefonnummer ein (optional)",
      "contact.form.message": "Nachricht",
      "contact.form.message_placeholder":
        "Schreiben Sie Ihre Nachricht hier...",
      "contact.form.submit": "Nachricht senden",
      "contact.success.title": "Erfolg!",
      "contact.success.message":
        "Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns so schnell wie möglich bei Ihnen melden.",
      "contact.success.close": "Schließen",
      "contact.error":
        "Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.",

      // Exhibitions
      "exhibitions.title": "Ausstellungen",
      "exhibitions.add_new": "Neue Ausstellung hinzufügen",
      "exhibitions.name": "Ausstellungsname",
      "exhibitions.description": "Beschreibung",
      "exhibitions.country": "Land",
      "exhibitions.city": "Stadt",
      "exhibitions.date": "Datum",
      "exhibitions.start_date": "Startdatum",
      "exhibitions.end_date": "Enddatum",
      "exhibitions.venue": "Veranstaltungsort",
      "exhibitions.organizer": "Veranstalter",
      "exhibitions.website": "Website",
      "exhibitions.contact": "Kontakt",
      "exhibitions.photos": "Fotos",
      "exhibitions.add_photo": "Foto hinzufügen",
      "exhibitions.remove_photo": "Foto entfernen",
      "exhibitions.no_photos": "Noch keine Fotos",
      "exhibitions.view_details": "Details anzeigen",
      "exhibitions.edit_exhibition": "Ausstellung bearbeiten",
      "exhibitions.delete_exhibition": "Ausstellung löschen",
      "exhibitions.confirm_delete":
        "Sind Sie sicher, dass Sie diese Ausstellung löschen möchten?",
      "exhibitions.created_successfully": "Ausstellung erfolgreich erstellt",
      "exhibitions.updated_successfully":
        "Ausstellung erfolgreich aktualisiert",
      "exhibitions.deleted_successfully": "Ausstellung erfolgreich gelöscht",
      "exhibitions.loading_error": "Fehler beim Laden der Ausstellungen",

      // Countries
      "countries.title": "Länder",
      "countries.add_new": "Neues Land hinzufügen",
      "countries.name": "Ländername",
      "countries.code": "Ländercode",
      "countries.flag": "Flagge",
      "countries.capital": "Hauptstadt",
      "countries.population": "Bevölkerung",
      "countries.region": "Region",
      "countries.subregion": "Unterregion",
      "countries.languages": "Sprachen",
      "countries.currencies": "Währungen",
      "countries.timezones": "Zeitzonen",
      "countries.view_exhibitions": "Ausstellungen anzeigen",
      "countries.edit_country": "Land bearbeiten",
      "countries.delete_country": "Land löschen",
      "countries.confirm_delete":
        "Sind Sie sicher, dass Sie dieses Land löschen möchten?",
      "countries.created_successfully": "Land erfolgreich erstellt",
      "countries.updated_successfully": "Land erfolgreich aktualisiert",
      "countries.deleted_successfully": "Land erfolgreich gelöscht",
      "countries.loading_error": "Fehler beim Laden der Länder",

      // Admin
      "admin.title": "Admin-Panel",
      "admin.dashboard": "Dashboard",
      "admin.manage_exhibitions": "Ausstellungen verwalten",
      "admin.manage_countries": "Länder verwalten",
      "admin.manage_users": "Benutzer verwalten",
      "admin.settings": "Einstellungen",
      "admin.statistics": "Statistiken",
      "admin.total_exhibitions": "Gesamte Ausstellungen",
      "admin.total_countries": "Gesamte Länder",
      "admin.total_users": "Gesamte Benutzer",
      "admin.recent_activity": "Letzte Aktivitäten",

      // Admin Contact Messages
      "admin.contact_messages.title": "Kontaktnachrichten",
      "admin.contact_messages.name": "Vollständiger Name",
      "admin.contact_messages.email": "E-Mail",
      "admin.contact_messages.phone": "Telefon",
      "admin.contact_messages.message": "Nachricht",
      "admin.contact_messages.status": "Status",
      "admin.contact_messages.date": "Datum",
      "admin.contact_messages.message_details": "Nachrichtendetails",
      "admin.contact_messages.mark_read": "Als gelesen markieren",
      "admin.contact_messages.mark_replied": "Als beantwortet markieren",
      "admin.contact_messages.no_messages": "Noch keine Nachrichten",

      // Auth
      "auth.login": "Anmelden",
      "auth.logout": "Abmelden",
      "auth.register": "Registrieren",
      "auth.email": "E-mail",
      "auth.password": "Passwort",
      "auth.confirm_password": "Passwort bestätigen",
      "auth.remember_me": "Angemeldet bleiben",
      "auth.forgot_password": "Passwort vergessen",
      "auth.login_successful": "Erfolgreich angemeldet",
      "auth.logout_successful": "Erfolgreich abgemeldet",
      "auth.invalid_credentials": "E-mail oder Passwort ungültig",
      "auth.required_field": "Dieses Feld ist erforderlich",
      "auth.invalid_email": "Ungültige E-Mail-Adresse",
      "auth.password_mismatch": "Les mots de passe ne correspondent pas",

      // Forms
      "form.required": "Dieses Feld ist erforderlich",
      "form.invalid_format": "Ungültiges Format",
      "form.min_length": "Muss mindestens {{min}} Zeichen lang sein",
      "form.max_length": "Darf maximal {{max}} Zeichen lang sein",
      "form.invalid_url": "Ungültige URL",
      "form.invalid_date": "Ungültiges Datum",

      // Messages
      "message.success": "Vorgang erfolgreich",
      "message.error": "Ein Fehler s'est produit",
      "message.warning": "Warnung",
      "message.info": "Information",

      // Language
      "language.turkish": "Türkçe",
      "language.english": "English",
      "language.german": "Deutsch",
      "language.spanish": "Español",
      "language.french": "Français",
      "language.select": "Sprache auswählen",
      "language.change": "Sprache ändern",

      // Footer
      "footer.description":
        "Wir sind führend in der Textilherstellung mit Innovation und Qualität.",
      "footer.quick_links": "Schnelllinks",
      "footer.about": "Über uns",
      "footer.careers": "Karriere",
      "footer.contact": "Kontakt",
      "footer.email": "E-mail: info@tekstas.com",
      "footer.phone": "Telefon: +90 123 456 7890",
      "footer.address": "Adresse: Istanbul, Türkei",
      "footer.follow_us": "Folgen Sie uns",
      "footer.copyright": "© 2023 Tekstas. Alle Rechte vorbehalten.",

      // About Section
      "about.title": "Über uns",
    },
  },
  es: {
    translation: {
      // Navigation
      "nav.home": "Inicio",
      "nav.exhibitions": "Exposiciones",
      "nav.countries": "Países",
      "nav.admin": "Admin",
      "nav.login": "Iniciar Sesión",
      "nav.logout": "Cerrar Sesión",
      "nav.about": "Acerca de",
      "nav.certificates": "Certificados",
      "nav.careers": "Recursos Humanos",
      "nav.contact": "Contacto",

      // Common
      "common.loading": "Cargando...",
      "common.error": "Ocurrió un error",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.add": "Agregar",
      "common.back": "Atrás",
      "common.next": "Siguiente",
      "common.previous": "Anterior",
      "common.close": "Cerrar",
      "common.search": "Buscar",
      "common.filter": "Filtrar",
      "common.all": "Todos",
      "common.yes": "Sí",
      "common.no": "No",
      "common.confirm": "Confirmar",
      "common.schedule_call": "Programar Llamada",

      // Home page
      "home.welcome": "Bienvenido",
      "home.description": "Descubre exposiciones alrededor del mundo",
      "home.featured_exhibitions": "Exposiciones Destacadas",
      "home.view_all": "Ver Todo",

      // Hero Section
      "hero.global_partner": "Su Socio Textil Global",
      "hero.reliable_production": "Producción Confiable Telas de Alta Calidad",
      "hero.global_partner_desc":
        "Ofrecemos producción confiable y altos estándares de calidad en la industria textil",
      "hero.innovation": "Innovación en Textil",
      "hero.premium_solutions": "Soluciones Sostenibles de Calidad Premium",
      "hero.innovation_desc":
        "Experimente el futuro de la fabricación textil con nuestras soluciones innovadoras",

      // Products Section
      "products.title":
        "Como marca especializada en la producción de tejidos desde 1980, situamos las fibras naturales en el centro de nuestros procesos de producción. Fabricamos bajo pedido según las necesidades de nuestros clientes, sin comprometer en ningún momento nuestros estándares de calidad. Con nuestra experiencia y enfoque meticuloso del trabajo, nos comprometemos con una producción fiable y sostenible.",
      "products.description":
        "Como marca especializada en la producción de tejidos desde 1980, situamos las fibras naturales en el centro de nuestros procesos de producción. Fabricamos bajo pedido según las necesidades de nuestros clientes, sin comprometer en ningún momento nuestros estándares de calidad. Con nuestra experiencia y enfoque meticuloso del trabajo, nos comprometemos con una producción fiable y sostenible.",

      // Features Section
      "features.title": "Nuestro producto",
      "features.description":
        "Explore nuestra cuidadosamente seleccionada colección de telas premium. Desde algodón transpirable hasta lino lujoso y sarga duradera, cada tela está diseñada para ofrecer estilo, comodidad y calidad duradera para sus camisas.",
      "features.view_all": "Ver Todas las Telas",
      "features.cotton.title": "Algodón",
      "features.cotton.description":
        "Suaves, transpirables y duraderos, nuestros tejidos de algodón ofrecen comodidad máxima y versatilidad para todos los tipos de camisas. Perfectos tanto para uso casual como formal, proporcionan un aspecto nítido mientras mantienen la comodidad durante todo el día.",
      "features.linen.title": "Lino",
      "features.linen.description":
        "Nuestros tejidos de lino son ligeros, aireados y perfectos para climas cálidos. Conocidos por su textura natural y transpirabilidad, las camisas de lino son ideales para un estilo relajado pero sofisticado.",
      "features.twill.title": "Sarga",
      "features.twill.description":
        "Los tejidos de sarga proporcionan una sensación lujosa con su acabado suave y tejido diagonal sutil. Estos tejidos son perfectos para crear camisas duraderas y de alta calidad con un aspecto refinado y elegante.",

      // Certificates Section
      "certificates.title": "Nuestras Certificaciones",
      "certificates.subtitle":
        "Estándares reconocidos de excelencia en la fabricación textil",
      "certificates.iso.title": "ISO 9001:2015",
      "certificates.iso.description":
        "Certificación internacional del sistema de gestión de calidad que asegura nuestro compromiso de proporcionar productos y servicios textiles de alta calidad.",
      "certificates.gots.title": "Certificación GOTS",
      "certificates.gots.description":
        "Certificación del Estándar Global de Textiles Orgánicos que confirma nuestro compromiso con la producción textil orgánica y las prácticas sostenibles.",
      "certificates.ocs.title": "Certificación OCS",
      "certificates.ocs.description":
        "El Estándar de Contenido Orgánico tiene como objetivo aumentar la producción agrícola orgánica.",
      "certificates.rcs.title": "Certificación RCS",
      "certificates.rcs.description":
        "Global Organic Textile Standard (GOTS) y Textile Exchange son los dos programas de certificación más comunes en la industria textil y de la confección. GOTS se centra principalmente en la certificación de textiles orgánicos, mientras que Textile Exchange gestiona varios estándares ampliamente reconocidos en torno a materiales orgánicos, reciclados y responsables.",

      // Fairs Section
      "fairs.title": "Nuestras Ferias Comerciales",
      "fairs.subtitle":
        "Tomando nuestro lugar en exposiciones textiles mondiales",
      "fairs.view_all": "Ver Todas las Ferias",

      // Careers Section
      "careers.title": "Únase a Nuestro Equipo",
      "careers.description":
        "Siempre estamos buscando individuos talentosos para unirse a nuestro equipo en crecimiento. Si está apasionado por la textil y la innovación, nos encantaría saber de usted. Envíe su solicitud y conviértase en parte de nuestra historia de éxito.",
      "careers.form.full_name": "Nombre Completo",
      "careers.form.full_name_placeholder": "Ingrese su nombre completo",
      "careers.form.email": "Correo Electrónico",
      "careers.form.email_placeholder": "Ingrese su correo electrónico",
      "careers.form.phone": "Teléfono",
      "careers.form.phone_placeholder": "Ingrese su número de teléfono",
      "careers.form.position": "Posición",
      "careers.form.position_placeholder":
        "Posición para la que está aplicando",
      "careers.form.message": "Mensaje",
      "careers.form.message_placeholder": "Su mensaje",
      "careers.form.file": "CV / Subir Archivo",
      "careers.form.file_selected": "Archivo seleccionado:",
      "careers.form.file_size_error":
        "El tamaño del archivo debe ser menor a 5MB",
      "careers.form.file_type_error": "Solo se aceptan archivos JPG, PNG y PDF",
      "careers.form.file_help":
        "Puede subir archivos JPG, PNG o PDF. Tamaño máximo del archivo: 5MB",
      "careers.form.submit": "Enviar Solicitud",
      "careers.success.title": "¡Éxito!",
      "careers.success.message":
        "Votre candidature a été soumise avec succès. Nous vous contacterons bientôt.",
      "careers.success.close": "Fermer",
      "careers.error":
        "Erreur lors de la soumission de la candidature. Veuillez réessayer.",

      // Contact Section
      "contact.title": "Contacto",
      "contact.description":
        "Póngase en contacto con nosotros. Puede usar el formulario de abajo para sus preguntas, sugerencias o solicitudes de colaboración. Nos pondremos en contacto con usted lo antes posible.",
      "contact.form.full_name": "Nombre Completo",
      "contact.form.full_name_placeholder": "Ingrese su nombre completo",
      "contact.form.email": "Correo Electrónico",
      "contact.form.email_placeholder": "Ingrese su correo electrónico",
      "contact.form.phone": "Teléfono",
      "contact.form.phone_placeholder":
        "Ingrese su número de teléfono (opcional)",
      "contact.form.message": "Mensaje",
      "contact.form.message_placeholder": "Escriba su mensaje aquí...",
      "contact.form.submit": "Enviar Mensaje",
      "contact.success.title": "¡Éxito!",
      "contact.success.message":
        "Su mensaje ha sido enviado exitosamente. Nos pondremos en contacto con usted lo antes posible.",
      "contact.success.close": "Cerrar",
      "contact.error": "Error al enviar mensaje. Por favor intente de nuevo.",

      // Exhibitions
      "exhibitions.title": "Exposiciones",
      "exhibitions.add_new": "Agregar Nueva Exposición",
      "exhibitions.name": "Nombre de la Exposición",
      "exhibitions.description": "Descripción",
      "exhibitions.country": "País",
      "exhibitions.city": "Ciudad",
      "exhibitions.date": "Fecha",
      "exhibitions.start_date": "Fecha de Inicio",
      "exhibitions.end_date": "Fecha de Fin",
      "exhibitions.venue": "Lugar",
      "exhibitions.organizer": "Organizador",
      "exhibitions.website": "Sitio Web",
      "exhibitions.contact": "Contacto",
      "exhibitions.photos": "Fotos",
      "exhibitions.add_photo": "Agregar Foto",
      "exhibitions.remove_photo": "Eliminar Foto",
      "exhibitions.no_photos": "Aún no hay fotos",
      "exhibitions.view_details": "Voir les Détails",
      "exhibitions.edit_exhibition": "Modifier l'Exposition",
      "exhibitions.delete_exhibition": "Supprimer l'Exposition",
      "exhibitions.confirm_delete":
        "Êtes-vous sûr de vouloir supprimer cette exposition ?",
      "exhibitions.created_successfully": "Exposición creada exitosamente",
      "exhibitions.updated_successfully": "Exposición actualizada exitosamente",
      "exhibitions.deleted_successfully": "Exposición eliminada exitosamente",
      "exhibitions.loading_error": "Error al cargar exposiciones",

      // Countries
      "countries.title": "Países",
      "countries.add_new": "Agregar Nuevo País",
      "countries.name": "Nom du Pays",
      "countries.code": "Code du Pays",
      "countries.flag": "Drapeau",
      "countries.capital": "Capitale",
      "countries.population": "Population",
      "countries.region": "Région",
      "countries.subregion": "Sous-région",
      "countries.languages": "Langues",
      "countries.currencies": "Devises",
      "countries.timezones": "Fuseaux Horaires",
      "countries.view_exhibitions": "Voir les Expositions",
      "countries.edit_country": "Modifier le Pays",
      "countries.delete_country": "Supprimer le Pays",
      "countries.confirm_delete":
        "Êtes-vous sûr de vouloir supprimer ce pays ?",
      "countries.created_successfully": "Pays créé avec succès",
      "countries.updated_successfully": "Pays mis à jour avec succès",
      "countries.deleted_successfully": "Pays supprimé avec succès",
      "countries.loading_error": "Erreur lors du chargement des pays",

      // Admin
      "admin.title": "Panel de Administración",
      "admin.dashboard": "Tableau de Bord",
      "admin.manage_exhibitions": "Gérer les Expositions",
      "admin.manage_countries": "Gérer les Pays",
      "admin.manage_users": "Gérer les Utilisateurs",
      "admin.settings": "Paramètres",
      "admin.statistics": "Statistiques",
      "admin.total_exhibitions": "Total des Expositions",
      "admin.total_countries": "Total des Pays",
      "admin.total_users": "Total des Utilisateurs",
      "admin.recent_activity": "Activité Récente",

      // Auth
      "auth.login": "Se Connecter",
      "auth.logout": "Se Déconnecter",
      "auth.register": "S'Inscrire",
      "auth.email": "E-mail",
      "auth.password": "Mot de Passe",
      "auth.confirm_password": "Confirmer le Mot de Passe",
      "auth.remember_me": "Se Souvenir de Moi",
      "auth.forgot_password": "Mot de Passe Oublié",
      "auth.login_successful": "Connexion réussie",
      "auth.logout_successful": "Déconnexion réussie",
      "auth.invalid_credentials": "E-mail ou mot de passe invalide",
      "auth.required_field": "Ce champ est requis",
      "auth.invalid_email": "Adresse e-mail invalide",
      "auth.password_mismatch": "Les mots de passe ne correspondent pas",

      // Forms
      "form.required": "Ce champ est requis",
      "form.invalid_format": "Format invalide",
      "form.min_length": "Doit contenir au moins {{min}} caractères",
      "form.max_length": "Doit contenir au maximum {{max}} caractères",
      "form.invalid_url": "URL invalide",
      "form.invalid_date": "Date invalide",

      // Messages
      "message.success": "Opération réussie",
      "message.error": "Une erreur s'est produite",
      "message.warning": "Avertissement",
      "message.info": "Information",

      // Language
      "language.turkish": "Türkçe",
      "language.english": "English",
      "language.german": "Deutsch",
      "language.spanish": "Español",
      "language.french": "Français",
      "language.select": "Sélectionner la Langue",
      "language.change": "Changer de Langue",

      // Footer
      "footer.description":
        "Liderando el camino en la fabricación textil con innovación y calidad.",
      "footer.quick_links": "Enlaces Rápidos",
      "footer.about": "Acerca de",
      "footer.careers": "Carreras",
      "footer.contact": "Contacto",
      "footer.email": "Correo: info@tekstas.com",
      "footer.phone": "Téléphone: +90 123 456 7890",
      "footer.address": "Dirección: Estambul, Turquía",
      "footer.follow_us": "Síguenos",
      "footer.copyright": "© 2023 Tekstas. Todos droits réservés.",

      // About Section
      "about.title": "Acerca de",
    },
  },
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.exhibitions": "Expositions",
      "nav.countries": "Pays",
      "nav.admin": "Admin",
      "nav.login": "Se Connecter",
      "nav.logout": "Se Déconnecter",
      "nav.about": "À Propos",
      "nav.certificates": "Certifications",
      "nav.careers": "Ressources Humaines",
      "nav.contact": "Contact",

      // Common
      "common.loading": "Chargement...",
      "common.error": "Une erreur s'est produite",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.add": "Ajouter",
      "common.back": "Retour",
      "common.next": "Suivant",
      "common.previous": "Précédent",
      "common.close": "Fermer",
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.all": "Tous",
      "common.yes": "Oui",
      "common.no": "Non",
      "common.confirm": "Confirmer",
      "common.schedule_call": "Planifier un Appel",

      // Home page
      "home.welcome": "Bienvenue",
      "home.description": "Découvrez les expositions du monde entier",
      "home.featured_exhibitions": "Expositions en Vedette",
      "home.view_all": "Voir Tout",

      // Hero Section
      "hero.global_partner": "Votre Partenaire Textile Mondial",
      "hero.reliable_production": "Production Fiable Tissus de Haute Qualité",
      "hero.global_partner_desc":
        "Nous offrons une production fiable et des normes de qualité élevées dans l'industrie textile",
      "hero.innovation": "Innovation dans le Textile",
      "hero.premium_solutions": "Solutions Durables de Qualité Premium",
      "hero.innovation_desc":
        "Découvrez l'avenir de la fabrication textile avec nos solutions innovantes",

      // Products Section
      "products.title":
        "En tant que marque spécialisée dans la production de tissus depuis 1980, nous plaçons les fibres naturelles au cœur de nos processus de fabrication. Nous produisons sur mesure selon les besoins de nos clients, sans jamais compromettre nos normes de qualité à aucune étape. Grâce à notre expérience et à notre approche méticuleuse du travail, nous nous engageons en faveur d'une production fiable et durable.",
      "products.description":
        "En tant que marque spécialisée dans la production de tissus depuis 1980, nous plaçons les fibres naturelles au cœur de nos processus de fabrication. Nous produisons sur mesure selon les besoins de nos clients, sans jamais compromettre nos normes de qualité à aucune étape. Grâce à notre expérience et à notre approche méticuleuse du travail, nous nous engageons en faveur d'une production fiable et durable.",

      // Features Section
      "features.title": "Notre produit",
      "features.description":
        "Explorez notre collection soigneusement sélectionnée de tissus premium. Du coton respirant au lin luxueux et au sergé durable, chaque tissu est conçu pour offrir style, confort et qualité durable pour vos chemises.",
      "features.view_all": "Voir Tous les Tissus",
      "features.cotton.title": "Coton",
      "features.cotton.description":
        "Doux, respirant et durable, nos tissus de coton offrent un confort ultime et une polyvalence pour tous les types de chemises. Parfaits pour les vêtements décontractés et formels, ils offrent un look net tout en maintenant le confort tout au long de la journée.",
      "features.linen.title": "Lin",
      "features.linen.description":
        "Nos tissus de lin sont légers, aérés et parfaits pour les temps chauds. Connus pour leur texture naturelle et leur respirabilité, les chemises en lin sont idéales pour un style décontracté mais sophistiqué.",
      "features.twill.title": "Sergé",
      "features.twill.description":
        "Les tissus de sergé offrent une sensation luxueuse avec leur finition lisse et leur armure diagonale subtile. Ces tissus sont parfaits pour créer des chemises durables et de haute qualité avec un look raffiné et élégant.",

      // Certificates Section
      "certificates.title": "Nos Certifications",
      "certificates.subtitle":
        "Normes reconnues d'excellence dans la fabrication textile",
      "certificates.iso.title": "ISO 9001:2015",
      "certificates.iso.description":
        "Certification internationale du système de gestion de la qualité assurant notre engagement à fournir des produits et services textiles de haute qualité.",
      "certificates.gots.title": "Certification GOTS",
      "certificates.gots.description":
        "Certification du Standard Global des Textiles Organiques confirmant notre dévouement à la production textile biologique et aux pratiques durables.",
      "certificates.ocs.title": "Certification OCS",
      "certificates.ocs.description":
        "La norme Organic Content Standard vise à accroître la production agricole biologique.",
      "certificates.rcs.title": "Certification RCS",
      "certificates.rcs.description":
        "Global Organic Textile Standard (GOTS) et Textile Exchange sont les deux programmes de certification les plus courants dans l'industrie du textile et de l'habillement. GOTS se concentre principalement sur la certification des textiles biologiques, tandis que Textile Exchange gère plusieurs normes largement reconnues autour des matériaux biologiques, recyclés et responsables.",

      // Fairs Section
      "fairs.title": "Nos Salons Commerciaux",
      "fairs.subtitle":
        "Prenant notre place dans les expositions textiles mondiales",
      "fairs.view_all": "Voir Tous les Salons",

      // Careers Section
      "careers.title": "Rejoignez Notre Équipe",
      "careers.description":
        "Nous recherchons toujours des individus talentueux pour rejoindre notre équipe en croissance. Si vous êtes passionné par le textile et l'innovation, nous aimerions avoir de vos nouvelles. Soumettez votre candidature et devenez partie de notre histoire de succès.",
      "careers.form.full_name": "Nom Complet",
      "careers.form.full_name_placeholder": "Entrez votre nom complet",
      "careers.form.email": "E-mail",
      "careers.form.email_placeholder": "Entrez votre e-mail",
      "careers.form.phone": "Téléphone",
      "careers.form.phone_placeholder": "Entrez votre numéro de téléphone",
      "careers.form.position": "Poste",
      "careers.form.position_placeholder": "Poste pour lequel vous postulez",
      "careers.form.message": "Message",
      "careers.form.message_placeholder": "Votre message",
      "careers.form.file": "CV / Télécharger un Fichier",
      "careers.form.file_selected": "Fichier sélectionné:",
      "careers.form.file_size_error":
        "La taille du fichier doit être inférieure à 5MB",
      "careers.form.file_type_error":
        "Seuls les fichiers JPG, PNG et PDF sont acceptés",
      "careers.form.file_help":
        "Vous pouvez télécharger des fichiers JPG, PNG ou PDF. Taille maximale du fichier: 5MB",
      "careers.form.submit": "Soumettre la Candidature",
      "careers.success.title": "Succès !",
      "careers.success.message":
        "Votre candidature a été soumise avec succès. Nous vous contacterons bientôt.",
      "careers.success.close": "Fermer",
      "careers.error":
        "Erreur lors de la soumission de la candidature. Veuillez réessayer.",

      // Contact Section
      "contact.title": "Contact",
      "contact.description":
        "Contactez-nous. Vous pouvez utiliser le formulaire ci-dessous pour vos questions, suggestions ou demandes de collaboration. Nous vous répondrons dans les plus brefs délais.",
      "contact.form.full_name": "Nom Complet",
      "contact.form.full_name_placeholder": "Entrez votre nom complet",
      "contact.form.email": "E-mail",
      "contact.form.email_placeholder": "Entrez votre adresse e-mail",
      "contact.form.phone": "Téléphone",
      "contact.form.phone_placeholder":
        "Entrez votre numéro de téléphone (optionnel)",
      "contact.form.message": "Message",
      "contact.form.message_placeholder": "Écrivez votre message ici...",
      "contact.form.submit": "Envoyer le Message",
      "contact.success.title": "Succès !",
      "contact.success.message":
        "Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.",
      "contact.success.close": "Fermer",
      "contact.error": "Erreur lors de l'envoi du message. Veuillez réessayer.",

      // Exhibitions
      "exhibitions.title": "Expositions",
      "exhibitions.add_new": "Ajouter une Nouvelle Exposition",
      "exhibitions.name": "Nom de l'Exposition",
      "exhibitions.description": "Description",
      "exhibitions.country": "Pays",
      "exhibitions.city": "Ville",
      "exhibitions.date": "Date",
      "exhibitions.start_date": "Date de Début",
      "exhibitions.end_date": "Date de Fin",
      "exhibitions.venue": "Lieu",
      "exhibitions.organizer": "Organisateur",
      "exhibitions.website": "Site Web",
      "exhibitions.contact": "Contact",
      "exhibitions.photos": "Photos",
      "exhibitions.add_photo": "Ajouter une Photo",
      "exhibitions.remove_photo": "Supprimer la Photo",
      "exhibitions.no_photos": "Aucune photo pour le moment",
      "exhibitions.view_details": "Voir les Détails",
      "exhibitions.edit_exhibition": "Modifier l'Exposition",
      "exhibitions.delete_exhibition": "Supprimer l'Exposition",
      "exhibitions.confirm_delete":
        "Êtes-vous sûr de vouloir supprimer cette exposition ?",
      "exhibitions.created_successfully": "Exposition créée avec succès",
      "exhibitions.updated_successfully": "Exposition mise à jour avec succès",
      "exhibitions.deleted_successfully": "Exposition supprimée avec succès",
      "exhibitions.loading_error": "Erreur lors du chargement des expositions",

      // Countries
      "countries.title": "Pays",
      "countries.add_new": "Ajouter un Nouveau Pays",
      "countries.name": "Nom du Pays",
      "countries.code": "Code du Pays",
      "countries.flag": "Drapeau",
      "countries.capital": "Capitale",
      "countries.population": "Population",
      "countries.region": "Région",
      "countries.subregion": "Sous-région",
      "countries.languages": "Langues",
      "countries.currencies": "Devises",
      "countries.timezones": "Fuseaux Horaires",
      "countries.view_exhibitions": "Voir les Expositions",
      "countries.edit_country": "Modifier le Pays",
      "countries.delete_country": "Supprimer le Pays",
      "countries.confirm_delete":
        "Êtes-vous sûr de vouloir supprimer ce pays ?",
      "countries.created_successfully": "Pays créé avec succès",
      "countries.updated_successfully": "Pays mis à jour avec succès",
      "countries.deleted_successfully": "Pays supprimé avec succès",
      "countries.loading_error": "Erreur lors du chargement des pays",

      // Admin
      "admin.title": "Panneau d'Administration",
      "admin.dashboard": "Tableau de Bord",
      "admin.manage_exhibitions": "Gérer les Expositions",
      "admin.manage_countries": "Gérer les Pays",
      "admin.manage_users": "Gérer les Utilisateurs",
      "admin.settings": "Paramètres",
      "admin.statistics": "Statistiques",
      "admin.total_exhibitions": "Total des Expositions",
      "admin.total_countries": "Total des Pays",
      "admin.total_users": "Total des Utilisateurs",
      "admin.recent_activity": "Activité Récente",

      // Auth
      "auth.login": "Se Connecter",
      "auth.logout": "Se Déconnecter",
      "auth.register": "S'Inscrire",
      "auth.email": "E-mail",
      "auth.password": "Mot de Passe",
      "auth.confirm_password": "Confirmer le Mot de Passe",
      "auth.remember_me": "Se Souvenir de Moi",
      "auth.forgot_password": "Mot de Passe Oublié",
      "auth.login_successful": "Connexion réussie",
      "auth.logout_successful": "Déconnexion réussie",
      "auth.invalid_credentials": "E-mail ou mot de passe invalide",
      "auth.required_field": "Ce champ est requis",
      "auth.invalid_email": "Adresse e-mail invalide",
      "auth.password_mismatch": "Les mots de passe ne correspondent pas",

      // Forms
      "form.required": "Ce champ est requis",
      "form.invalid_format": "Format invalide",
      "form.min_length": "Doit contenir au moins {{min}} caractères",
      "form.max_length": "Doit contenir au maximum {{max}} caractères",
      "form.invalid_url": "URL invalide",
      "form.invalid_date": "Date invalide",

      // Messages
      "message.success": "Opération réussie",
      "message.error": "Une erreur s'est produite",
      "message.warning": "Avertissement",
      "message.info": "Information",

      // Language
      "language.turkish": "Türkçe",
      "language.english": "English",
      "language.german": "Deutsch",
      "language.spanish": "Español",
      "language.french": "Français",
      "language.select": "Sélectionner la Langue",
      "language.change": "Changer de Langue",

      // Footer
      "footer.description":
        "Leader dans la fabrication textile avec innovation et qualité.",
      "footer.quick_links": "Liens Rapides",
      "footer.about": "À Propos",
      "footer.careers": "Carrières",
      "footer.contact": "Contact",
      "footer.email": "E-mail : info@tekstas.com",
      "footer.phone": "Téléphone : +90 123 456 7890",
      "footer.address": "Adresse : Istanbul, Turquie",
      "footer.follow_us": "Suivez-nous",
      "footer.copyright": "© 2023 Tekstas. Tous droits réservés.",

      // About Section
      "about.title": "À Propos",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 